import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../truthDare.css";
import "./rules.css";
import { setBackButtonUrl } from "../uiSlice";
import useUnlockPageScroll from "../useUnlockPageScroll";
import useFitText from "../useFitText";

const MOBILE_QUERY = "(max-width: 768px)";

/** Player rules page from old/rules.php: custom title, rules list, Next -> game (no logo). */
export default function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status: themeStatus, data: themeData } = useSelector((s) => s.theme);
  const textRef = useRef(null);

  const rules = Array.isArray(themeData?.rules)
    ? themeData.rules.map((r) => String(r || "").trim()).filter(Boolean)
    : [];
  const title = themeData?.landing_page_title || "";
  const textColor = themeData?.landing_page_title_color;

  useUnlockPageScroll();

  // Shrink the title + rules until they fit inside the frame, so it never needs a scrollbar.
  useFitText(textRef, [title, rules.join("\n"), themeStatus], {
    min: window.matchMedia(MOBILE_QUERY).matches ? 0.45 : 0.3,
  });

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [dispatch]);

  if (themeStatus === "loading" && !themeData) {
    return (
      <div className="quiz-loader-container">
        <div className="quiz-loader" />
      </div>
    );
  }

  return (
    <div className="td-stage td-rules-stage">
      <div className="td-box td-rules-box">
        <div className="td-rules-content">
          <div className="td-rules-text" ref={textRef} style={{ color: textColor }}>
            {title ? <h3 className="td-rules-title">{title}</h3> : null}
            <ul className="td-rule-list">
              {rules.map((rule, i) => (
                <li key={i} style={{ animationDelay: `${0.15 + i * 0.12}s` }}>
                  <span className="td-rule-num" aria-hidden>
                    {i + 1}
                  </span>
                  <span className="td-rule-text">{rule}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <button type="button" className="td-cta td-rules-next" onClick={() => navigate("/game")}>
        Next <i className="fa-solid fa-angles-right" aria-hidden />
      </button>
    </div>
  );
}
